import * as React from 'react';
import LocalDiv from '../../localization/LocalDiv';
import { TABLE_STYLE } from '../../layout/table/style';
import Msg from '../../localization/Msg';
import { Str } from '../../localization/translationKeys';
import { Language } from '../../localization/models';
import { css } from '@emotion/core';
import { Report } from './models';
import FeedbackReportTableRow from './FeedbackReportTableRow';


const styles = {
  cells:        {
    reports:   css`
      min-width: 200px;
    `,
    delivered: css`
      min-width: 130px;
    `,
    language:  css`
      min-width: 125px;
    `,
    type:      css`
      min-width: 50px;
    `,
    navBtn:    css`
      min-width: 145px;
      padding: 5px !important;
    `,
  },
  link:         css`
    display: block;
    margin-left: 5px;
    margin-right: 5px;
  `,
  disabled:     css`
    cursor: default;
    opacity: .6;

    &:hover {
      text-decoration: none;
      cursor: default;
    }
  `,
};


type Props = {
  reports: Report[];
  showShareScoresColumn: boolean;
  code: string;

  showShareScoresBtn: (report: Report) => boolean;
  showDownloadReportBtn: (report: Report) => boolean;
  setReport: (report: Report) => void;
  onClickShareScoresBtn: (report: Report) => void;
  getLanguage: (languageId: number) => Language;

  className?: string;
};


/**
 * FeedbackReportTableData: a component that renders the feedback report table's report items as rows in the table.
 */
const FeedbackReportTableData: React.FC<Props> = (
  {
    reports,
    showShareScoresColumn,
    showShareScoresBtn,
    showDownloadReportBtn,
    setReport,
    onClickShareScoresBtn,
    getLanguage,
    code,
    className,
  },
) => (
  <LocalDiv className={className}>
    <table css={TABLE_STYLE}>
      <thead>
        <tr>
          <th css={styles.cells.reports}>
            <Msg str={Str.Reports} />
          </th>
          <th css={styles.cells.delivered}>
            <Msg str={Str.Delivered} />
          </th>
          <th css={styles.cells.language}>
            <Msg str={Str.Language} />
          </th>
          <th css={styles.cells.navBtn} />
          {
            showShareScoresColumn && (
              <th css={styles.cells.navBtn} />
            )
          }
        </tr>
      </thead>
      <tbody>
        {
          reports.map(
            report => (
              <FeedbackReportTableRow
                report={report}
                language={getLanguage(report.reportTemplateLanguageId)?.nativeName ?? ''}
                code={code}
                showDownloadReportBtn={showDownloadReportBtn(report)}
                showShareScoresBtn={showShareScoresColumn && showShareScoresBtn(report)}
                setReport={() => setReport(report)}
                onClickShareScoresBtn={() => onClickShareScoresBtn(report)}
              />
            ),
          )
        }
        {
          reports.length === 0 && (
            <tr>
              <td colSpan={4}>
                <Msg str={Str.NoReports} />
              </td>
            </tr>
          )
        }
      </tbody>
    </table>
  </LocalDiv>
);

export default FeedbackReportTableData;
